export default __webpack_public_path__ + "static/media/lunch.f73a2dd2.svg";